module.exports = __webpack_public_path__ + "media/images/collegelogos_rev2-2818a9ecaf1862b84d1dd248558693e9.jpg";